export const LANGUAGECODE = [
  { Name: "Swedish", Value: "sv" },
  { Name: "English", Value: "en" },
];
